import React from "react";

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20 space-y-8">
      <h1 className="text-4xl font-bold text-center">Terms of Service</h1>
      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 text-gray-300 space-y-6 leading-relaxed">
        
        <p><strong>Effective Date:</strong> January 1, 2026</p>

        <h2 className="text-xl font-bold text-white">1. Acceptance of Terms</h2>
        <p>
          By accessing and using All Stream Downloader ("the Service"), you agree to be bound by these Terms of Service. 
          If you disagree with any part of these terms, you may not access the Service.
        </p>

        <h2 className="text-xl font-bold text-white">2. User Responsibilities</h2>
        <p>
          You agree to use the Service only for lawful purposes. You are solely responsible for ensuring that your use of the Service complies with all applicable laws and regulations, including copyright laws.
        </p>
        <ul className="list-disc list-inside space-y-2 pl-4">
          <li>You may only download content that you have permission to download.</li>
          <li>You may not use the Service to distribute copyrighted material without authorization.</li>
          <li>You may not attempt to reverse engineer or overload the Service infrastructure.</li>
        </ul>

        <h2 className="text-xl font-bold text-white">3. Intellectual Property</h2>
        <p>
          The Service allows users to download third-party content. We do not host this content and do not claim ownership of any content downloaded through our platform. 
          All trademarks, logos, and copyrights remain the property of their respective owners.
        </p>

        <h2 className="text-xl font-bold text-white">4. Disclaimer of Warranties</h2>
        <p>
          The Service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, regarding the reliability, suitability, or availability of the service. 
          We do not guarantee that downloads will be successful or error-free.
        </p>

        <h2 className="text-xl font-bold text-white">5. Limitation of Liability</h2>
        <p>
          In no event shall All Stream Downloader or its operators be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of the Service.
        </p>
      </div>
    </div>
  );
};

export default Terms;